import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("akimart_lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("akimart_lang", lang);
    if (lang === "am") {
      document.documentElement.lang = "am";
    } else {
      document.documentElement.lang = "en";
    }
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
